// extracted by mini-css-extract-plugin
export default {"cls1":"PaperAbstract-cls1___c9704fff8924c7b4134","cls2":"PaperAbstract-cls2___43a08af1052837bc040 PaperAbstract-cls1___c9704fff8924c7b4134"};